import { VinovaAPIInstance } from '../configVinovaApi';
import { decryptObj, encryptObj } from 'helpers/encrypt';

export const paymentDetailApi = async (data: any) => {
  try {
    data = encryptObj(data);
    const res = await VinovaAPIInstance.post(
      `/api/policy/payment-portal/get-payment-detail`,
      data
    );
    const response = {
      'policy-paymentinfo': [decryptObj(res.data[0])],
    };
    return response;
  } catch (err) {
    console.log('err', err);
    return { response: err.response, error: true };
  }
};

export const businessDateApi = async (data: any) => {
  try {
    const res = await VinovaAPIInstance.post(
      `/api/policy/payment-portal/business-date2`,
      data
    );

    return res;
  } catch (err) {
    return { response: err.response, error: true };
  }
};

export const insurancetypeApi = async (data: any) => {
  try {
    const res = await VinovaAPIInstance.get(
      `api/policy/payment-portal/plancode-insurancetype?PlanCode=${data}`
    );
    return res;
  } catch (err) {
    return { response: err.response, error: true };
    // Promise.reject(err);
  }
};
